.radio {
  .icon {
    border-color: var(--rc-theme-color-border-default);
  }

  &:has(input:checked) {
    &:not(:has(input:disabled)) .icon {
      border-color: var(--rc-theme-color-primary-default);
      background-color: var(--rc-theme-color-surface-default);

      &::after {
        background-color: var(--rc-theme-color-primary-default);
      }
    }

    &:has(input:disabled) .icon {
      border-color: var(--rc-theme-color-text-disabled);

      &::after {
        background-color: var(--rc-theme-color-text-disabled);
      }
    }
  }

  &:has(input:disabled) {
    .icon {
      background-color: var(--rc-theme-color-surface-disabled);

      ~ .label {
        color: var(--rc-theme-color-text-disabled);
      }
    }
  }
}
